import { render } from "./ShippingButtons.vue?vue&type=template&id=78db175a&scoped=true"
import script from "./ShippingButtons.vue?vue&type=script&lang=js"
export * from "./ShippingButtons.vue?vue&type=script&lang=js"

import "./ShippingButtons.vue?vue&type=style&index=0&id=78db175a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78db175a"]])

export default __exports__